import { QueryClientProvider } from '@tanstack/react-query'
import { Provider as JotaiProvider } from 'jotai/react'
import { useHydrateAtoms } from 'jotai/react/utils'
import { queryClientAtom } from 'jotai-tanstack-query'
import React from 'react'

import { queryClient } from '../store/queryClient'

const HydrateAtoms = ({ children }: { children: React.ReactNode }) => {
  useHydrateAtoms(new Map([[queryClientAtom, queryClient]]))
  return <>{children}</>
}

export const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    <JotaiProvider>
      <HydrateAtoms>{children}</HydrateAtoms>
    </JotaiProvider>
  </QueryClientProvider>
)
